<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <cr-combine />
      </div>
    </div>
</section>
</template>

<script>
import crCombination from './Temp/CrCombinationTemp.vue'

export default {
  name: 'Tables',
  components: {
    'cr-combine': crCombination
  },
  methods: {
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    },
    checkInput () {
      return this.$parent.checkInput
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// UpCombination.vue?0ab42554